export default __webpack_public_path__ + "static/media/survey.c2ea5624.png";